import script from "./EsportFixtureDoubleMarketUpcoming.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportFixtureDoubleMarketUpcoming.vue?vue&type=script&setup=true&lang=js"

import "./EsportFixtureDoubleMarketUpcoming.vue?vue&type=style&index=0&id=3b354c8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b354c8f"]])

export default __exports__